import { Component, Input, ViewEncapsulation } from '@angular/core';
import { MicroMoments } from './models/micro-moments.interfaces';

@Component({
  selector: 'idp-micro-moments',
  templateUrl: './micro-moments.component.html',
  styleUrls: ['./micro-moments.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MicroMomentsComponent {
  @Input() content: MicroMoments = {} as MicroMoments;

  display = true;

  redirect(link: string) {
    window.open(link, '_blank');
  }
}
